import Api from "shared/service/api/api";

// actions
export const LOAD_COMMON = "loadCommon";

//mutations
export const SET_MESSAGE_TYPES = "setMessageTypes";
export const SET_ORDER_STATES = "setOrderTypes";
export const SET_MANAGERS = "setManagers";
export const SET_ITEM_DATA = "setItemData";
export const SET_FINANCE_DATA = "setFinanceData";
export const SET_USER_DATA = "setUserData";
export const SET_COURSE_LESSON_TYPES = "setLessonTypes";
export const SET_PROJECT_COMMON_LOADED = "setProjectCommonLoaded";

const state = {
  projectCommonLoaded: false,
  datasets: {
    messageTypes: [],
    orderStates: [],
    orderSubstates: [],
    managers: [],

    globalCategories: [],
    templates: [],
    priceTypes: [],
    sellValueTypes: [],
    itemTypes: [],
    itemStatusList: [],
    personalAgreementTemplate: "",

    payoutRequestStates: [],
    organizationForms: [],
    balanceTypes: [],
    deferrerPresets: [],

    serviceTypes: [],
    communicationMethods: [],

    lessonTypes: {},
  },
};

const getters = {
  projectCommonLoaded: (state) => state.projectCommonLoaded,
  orderStates: (state) => state.datasets.orderStates,
  managers: (state) => state.datasets.managers,
  itemTypes: (state) => state.datasets.itemTypes,
  itemStatusList: (state) => state.datasets.itemStatusList,
  globalCategories: (state) => state.datasets.globalCategories,
  templates: (state) => state.datasets.templates,
  personalAgreementTemplate: (state) => state.datasets.personalAgreementTemplate,
  priceTypes: (state) => state.datasets.priceTypes,
  sellValueTypes: (state) => state.datasets.sellValueTypes,
  messageTypes: (state) => state.datasets.messageTypes,
  orderSubstates: (state) => state.datasets.orderSubstates,
  payoutRequestStates: (state) => state.datasets.payoutRequestStates,
  organizationForms: (state) => state.datasets.organizationForms,
  balanceTypes: (state) => state.datasets.balanceTypes,
  deferrerPresets: (state) => state.datasets.deferrerPresets,
  serviceTypes: (state) => state.datasets.serviceTypes,
  communicationMethods: (state) => state.datasets.communicationMethods,
  lessonTypes: (state) => state.datasets.lessonTypes,
};

const actions = {
  [LOAD_COMMON]({ commit }) {
    return Api.project.common().then((response) => {
      commit(SET_MESSAGE_TYPES, response.data.message_type);
      commit(SET_ORDER_STATES, response.data.order);
      commit(SET_MANAGERS, response.data.managers);
      commit(SET_ITEM_DATA, response.data.item);
      commit(SET_FINANCE_DATA, response.data.finance);
      commit(SET_USER_DATA, response.data.user);
      commit(SET_COURSE_LESSON_TYPES, response.data.course.lesson);
      commit(SET_PROJECT_COMMON_LOADED);

      return response;
    });
  },
};

const mutations = {
  [SET_MESSAGE_TYPES](state, messageTypes) {
    state.datasets.messageTypes = messageTypes;
  },
  [SET_ORDER_STATES](state, order) {
    state.datasets.orderStates = order.states;
    state.datasets.orderSubstates = order.substates;
  },
  [SET_MANAGERS](state, managers) {
    state.datasets.managers = managers;
  },
  [SET_ITEM_DATA](state, itemData) {
    state.datasets.globalCategories = itemData.globalCategories;
    state.datasets.templates = itemData.templates;
    state.datasets.priceTypes = itemData.priceTypes;
    state.datasets.sellValueTypes = itemData.sellValueTypes;
    state.datasets.itemTypes = itemData.types;
    state.datasets.itemStatusList = itemData.status_list;
    state.datasets.personalAgreementTemplate ||= itemData.personal_agreement_template;
  },
  [SET_FINANCE_DATA](state, financeData) {
    state.datasets.payoutRequestStates = financeData.payout_request_states;
    state.datasets.organizationForms = financeData.organization_forms;
    state.datasets.balanceTypes = financeData.balance_types;
    state.datasets.deferrerPresets = financeData.deferrer_presets;
  },
  [SET_USER_DATA](state, userData) {
    state.datasets.serviceTypes = userData.service_types;
    state.datasets.communicationMethods = userData.communication_methods;
  },
  [SET_COURSE_LESSON_TYPES](state, lessonTypes) {
    state.datasets.lessonTypes = lessonTypes;
  },
  [SET_PROJECT_COMMON_LOADED](state) {
    state.projectCommonLoaded = true;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
